export const SALES_DEPARTMENT_TOOL_MENU_ITEMS = [
  { key: 'project-details', label: 'Dashboard' },
  { key: 'project-details-iteneraries', label: 'Itineraries' },
  { key: 'project-details-map', label: 'MAP' },
  { key: 'project-details-info', label: 'Sales Performance Report' },
  { key: 'project-details-blueprint', label: 'Blue Print' },
  { key: 'project-details-focus-products', label: 'Focus Products' },
];

export const SALES_DEPARTMENT_TOOL_META = {
  'project-details': {
    title: 'Project Details Dashboard',
    description: 'Overview of project details and incentives',
  },
  'project-details-info': {
    title: 'Project Details',
    description: 'Detailed information about projects',
  },
  'project-details-iteneraries': {
    title: 'Itineraries',
    description: 'Manage sales itineraries',
  },
  'project-details-map': {
    title: 'MAP',
    description: 'Project mapping and locations',
  },
  'project-details-blueprint': {
    title: 'Blue Print',
    description: 'Project blueprints and layouts',
  },
  'project-details-performance': {
    title: 'Performance',
    description: 'Project performance metrics',
  },
  'project-details-incentives': {
    title: 'Incentives Computation',
    description: 'Incentives calculation and tracking',
  },
  'project-details-focus-products': {
    title: 'Focus Products',
    description: 'Focus products monitoring',
  },
  'sales-account-details': {
    title: 'sales-account-details',
    description: 'Detailed sales metrics',
  },
  'blueprint-account-details': {
    title: 'Blue Print',
    description: 'Project blueprints and layouts',
  },
};

export const SALES_DEPARTMENT_TOOL_ROUTE_KEYS = new Set(Object.keys(SALES_DEPARTMENT_TOOL_META));

export const isSalesDepartmentToolsRoute = (activeMenuItem) => SALES_DEPARTMENT_TOOL_ROUTE_KEYS.has(activeMenuItem);

export const getSalesDepartmentToolsMeta = (activeMenuItem, selectedSalesAccount) => {
  if (activeMenuItem === 'sales-account-details' && selectedSalesAccount) {
    return {
      title: `Sales Performance: ${selectedSalesAccount.full_name}`,
      description: `Detailed sales metrics for ${selectedSalesAccount.full_name}`,
    };
  }

  return SALES_DEPARTMENT_TOOL_META[activeMenuItem] || null;
};
